export const setGraphSettings = (state, action) => {
	state.settings = { ...state.settings, ...action.payload };
};

export const resetGraphSettings = (state) => {
	state.settings = {};
};
